"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterMultipleSelectCellFactory = void 0;
const common_types_1 = require("../../../common-types");
const react_1 = __importStar(require("react"));
const select_1 = require("../../../components/select/select");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
function useFilterMultipleSelectCellFactory(dataHook) {
    return (0, react_1.useMemo)(() => function FilterSelectCell({ disabled, filter, state, onChangeState, }) {
        var _a;
        const source = dataHook();
        const handleChange = (0, event_callback_hook_1.useEventCallback)((value) => {
            onChangeState({
                ...state,
                operation: common_types_1.ApiFilterOperation.OR,
                filters: constructNestedFilters(filter.filterkey, value),
                selectFilter: value,
            });
        });
        return (react_1.default.createElement(select_1.Select, { disabled: disabled, source: source, value: (_a = state.selectFilter) !== null && _a !== void 0 ? _a : [], onChange: handleChange, selectableAll: false, clearable: false, valueIsId: true, multiple: true }));
    }, [dataHook]);
}
exports.useFilterMultipleSelectCellFactory = useFilterMultipleSelectCellFactory;
function constructNestedFilters(field, values) {
    return (values !== null && values !== void 0 ? values : []).map((value) => ({
        field,
        operation: common_types_1.ApiFilterOperation.EQ,
        value,
    }));
}
//# sourceMappingURL=filter-multiple-select-cell.js.map